import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import { MdSearch, MdOutlineLogout } from "react-icons/md";
import Button from "react-bootstrap/Button";
import { Image } from "react-bootstrap";
import Dash3 from "../../assets/d-1.svg";
import Dash4 from "../../assets/d-2.svg";
import Savings from "../../assets/savings.svg";
import Dash5 from "../../assets/tc-1.svg";
import emailpic from "../../assets/email.svg";
import More from "../../assets/more.svg";
import More1 from "../../assets/m-1.svg";
import More2 from "../../assets/m-2.svg";
import More4 from "../../assets/m-4.svg";
import { Col, Row } from "react-bootstrap";
import add from "../../assets/add.svg";
import remove from "../../assets/remove.svg";
import { MdKeyboardArrowLeft } from "react-icons/md";
import Modal from "react-bootstrap/Modal";
import SideBar from "../SideBar/SideBar";
import TabsSection from "../Tabs/TabsSection";
import { BusinessListing } from "../API/BusinessListingAPI/BusinessListing";
import { BusinessListingPlus } from "./../API/BusinessListingAPI/BusinessListingPlus";
import Loader from "../../Components/Loader/Loader";
import { DeleteRowApi } from "./../API/BusinessListingAPI/DeleteRow";
import { UpdateStatusApi } from "./../API/BusinessListingAPI/UpdateStatus";
import Pagination from "../Pagination/Pagination";
import { saveAs } from "file-saver";
import { FaSort, FaSortUp, FaSortDown } from "react-icons/fa";
import { SortAPi } from "../API/BusinessListingAPI/SortApi";
import swal from "sweetalert";
import Dropdown from "react-bootstrap/Dropdown";
import arrowDown from "../../assets/arrow-down.png";
import { MdClose } from "react-icons/md";
import { EmailViewApi } from "./../API/BusinessListingAPI/EmailView";
import { BusinessPreviewAPi } from "./../API/BusinessListingAPI/BusinessPreview";

import { SaveRequestAPI } from "./../API/BusinessListingAPI/SaveRequest";
import NoDataText from "../NoDataText";
import { RequestPopupAPI } from "./../API/BusinessListingAPI/RequestPopup";
import SearchBarResults from "../Search/SearchBarResults";
import { CategorySelectAPI } from "../API/BusinessListingAPI/CategorySelect";
import { MarketPlaceCategoryListAPI } from "../API/BusinessListingAPI/MarketPlaceCategoryList";
import { Switch } from "antd";
import FeaturedListing from "./FeaturedListing";
import { UpdateFeatureStatusApi } from "./../API/BusinessListingAPI/UpdateFeatureStatus";
import { UpdateFeatureListApi } from "../API/BusinessListingAPI/UpdateFeatureList";
import { getFeaturedListingApi } from "../API/BusinessListingAPI/getFeaturedListing";
import BackButton from "../BackButton/BackButton";
import PrivacyTermsConditions from "./../PrivacyTermsConditions/PrivacyTermsConditions";
import { FormatDateShortMonth } from "../../Utils/DateFormatter";

const BusinessListings = () => {
  let navigate = useNavigate();
  const cityId = localStorage.getItem("cityId");

  const [loading, setLoading] = useState(false);
  const [TableRows, setTableRows] = useState([]);
  const [globalTableRows, setglobalTableRows] = useState([]);

  const [title, setTitle] = useState("");
  const [selctedRow, setselctedRow] = useState(null);
  const [expandedRows, setExpandedRows] = useState("");
  const [expandedRowsData, setExpandedRowsData] = useState({});
  const [listingNo, setlistingNo] = useState(5);
  //
  const [isCheckAll, setIsCheckAll] = useState(false);
  const [isCheck, setIsCheck] = useState([]);
  const [ShowTable, setShowTable] = useState(false);
  const [Nodata, setNodata] = useState(false);

  const [bussinessCategory, setbussinessCategory] = useState([]);

  // search
  const [searchValue, setsearchValue] = useState("");
  // pagination
  const [totalPageCount, setTotalPageCount] = useState(0);
  const [pageNumber, setPageNumber] = useState(0);
  const [limit, setLimit] = useState(0);
  // sort
  const [flag, setFlag] = useState({
    business_name: 0,
    category: 0,
    city: 0,
    applied_date: 0,
  });

  // popup-modal
  const [modalShow, setModalShow] = React.useState(false);
  const [EmailStatusmodalShow, setEmailStatusmodalShow] = React.useState(false);

  // request-popup
  const [request_id, setrequest_id] = useState([]);
  const [TriggerData, setTriggerData] = useState("");
  const [MissingFeildData, setMissingFeildData] = useState([]);
  const [RequestMessage, setRequestMessage] = useState("");

  const [openCount, setopenCount] = useState(0);
  const [ShowMissingFeilds, setShowMissingFeilds] = useState(false);
  const [isCheckAllMissingFeild, setIsCheckAllMissingFeild] = useState(false);
  const [isCheckMissingFeild, setIsCheckMissingFeild] = useState([]);
  const [isCheckMissingFeildvalue, setisCheckMissingFeildvalue] = useState([]);
  const [MissingFeildErr, setMissingFeildErr] = useState("");
  const [MessageEmptyErr, setMessageEmptyErr] = useState("");

  // veiwEmail
  const [EmailData, setEmailData] = useState([]);

  // feature-status
  const [featureStatus, setFeatureStatus] = useState({});
  const [items, setItems] = useState([]);
  const [isReorder, setIsReorder] = useState(false);

  const path = window.location.href;
  const endPath = path.split("/");

  const handleBussinessListing = async (tab_id) => {
    const data = {
      mms_city_id: parseInt(cityId),
      listing_for: tab_id,
      offset: pageNumber,
    };
    const coupondetailData = await BusinessListing(data, () => {
      navigate("/");
    });
    setLoading(false);
    if (coupondetailData == false) {
      swal({
        // title: "Error!",
        title: NoDataText.InternalErr,
        icon: "error",
        buttons: "Ok",
        dangerMode: true,
      });
    } else {
      if (coupondetailData.status === 429) {
        setLoading(true);
        setShowTable(false);
        swal({
          // title: "Error!",
          title: coupondetailData.message,
          icon: "error",
          // buttons: "Ok",
          dangerMode: true,
        });
      } else if (coupondetailData.message === "No Data Available") {
        setShowTable(true);
      } else {
        setShowTable(false);
        setTableRows(coupondetailData.data);
        setglobalTableRows(coupondetailData.data);
        setTotalPageCount(coupondetailData.total_count);
        setLimit(coupondetailData.limit);
      }
    }
  };

  useEffect(() => {
    setLoading(true);
    const url = endPath[4].replace(/-/g, " ");
    const arr = url.split(" ");
    for (var i = 0; i < arr.length; i++) {
      arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
    }
    const url_final = arr.join(" ");
    setTitle(url_final);

    if (endPath[4] === "all-listings") {
      handleBussinessListing(5);
      setlistingNo(5);
    }
    if (endPath[4] === "new-listings") {
      handleBussinessListing(1);
      setlistingNo(1);
    }
    if (endPath[4] === "in-review-listings") {
      handleBussinessListing(2);
      setlistingNo(2);
    }
    if (endPath[4] === "published-listings") {
      handleBussinessListing(3);
      setlistingNo(3);
    }
    if (endPath[4] === "declined-listings") {
      handleBussinessListing(4);
      setlistingNo(4);
    }
    if (endPath[4] === "featured-listings") {
      // handleBussinessListing(5);
      getListing();
      setlistingNo(5);
    }
  }, [path, pageNumber]);

  const handleOpenPlus = (e, key) => {
    setLoading(true);
    setselctedRow(key);
    const business_id = TableRows[key].bu_id;
    setExpandedRows(TableRows[key].bu_id);
    handlePlusShow(business_id, e, key);
  };

  const handlePlusShow = async (bu_id, e, key) => {
    const data = {
      mms_city_id: parseInt(cityId),
      bu_id: bu_id,
    };
    const BusinessListingPlusData = await BusinessListingPlus(data, () => {
      navigate("/");
    });

    if (BusinessListingPlusData == false) {
      swal({
        // title: "Error!",
        title: NoDataText.InternalErr,
        icon: "error",
        buttons: "Ok",
        dangerMode: true,
      });
    } else {
      if (BusinessListingPlusData.status === 429) {
        swal({
          // title: "Error!",
          title: BusinessListingPlusData.message,
          icon: "error",
          buttons: "Ok",
          dangerMode: true,
        });
        setLoading(true);
      } else if (BusinessListingPlusData.message == "No Data") {
        setNodata(true);
        setLoading(false);
      } else {
        setNodata(false);
        setExpandedRowsData(BusinessListingPlusData);
        setLoading(false);
      }
    }
  };

  const handleClosePlus = (e, key) => {
    setExpandedRows("");
    setselctedRow(null);
  };

  // checkbox - th
  const handleSelectAll = (e) => {
    setIsCheckAll(!isCheckAll);
    setIsCheck(TableRows.map((li) => li.business_info_id));
    if (isCheckAll) {
      setIsCheck([]);
    }
  };
  // checkbox - tr
  const handleClick = (e, key) => {
    const { checked } = e.target;
    setIsCheck([...isCheck, TableRows[key].business_info_id]);
    if (!checked) {
      setIsCheck(
        isCheck.filter((item) => item !== TableRows[key].business_info_id)
      );
    }
  };

  // update status
  const handleChangeDropDown = (e, key) => {
    setLoading(true);

    const data = {
      mms_city_id: parseInt(cityId),
      option: "status",
      actionIds: [TableRows[key].business_info_id],
      status_id: parseInt(e.target.value),
    };
    swal({
      title: `Are you sure you want to update status of ${TableRows[key].business_name}?`,
      icon: "warning",
      buttons: true,
      dangerMode: false,
    }).then((willDelete) => {
      if (willDelete) {
        setLoading(true);
        UpdateStatusApi(data, () => {
          navigate("/");
        });
        setTimeout(() => {
          setLoading(false);
          swal({
            title: `${TableRows[key].business_name} status has been updated successfully!`,
            icon: "success",
            buttons: "Ok",
          });
        }, 1000);
      } else {
        swal({
          text: "Please wait...",
          icon: "error",
          buttons: "Ok",
        });
        setTimeout(() => {
          window.location.reload(false);
        }, 1000);
      }
    });
    setLoading(false);
  };

  const handleChangeDropDownTop = (e) => {
    setLoading(true);
    const data = {
      mms_city_id: parseInt(cityId),
      option: "status",
      actionIds: isCheck,
      status_id: parseInt(e.target.value),
    };
    swal({
      title: `Are you sure you want to update status for selected business?`,
      icon: "warning",
      buttons: true,
      dangerMode: false,
    }).then((willDelete) => {
      if (willDelete) {
        setLoading(true);
        UpdateStatusApi(data, () => {
          navigate("/");
        });
        setTimeout(() => {
          setLoading(false);
          swal({
            title: `Selected business status has been updated successfully!`,
            icon: "success",
            buttons: "Ok",
          }).then((ok) => {
            if (ok) {
              setTimeout(() => {
                window.location.reload(false);
              }, 100);
            }
          });
        }, 1000);
      } else {
        swal({
          text: "Please wait...",
          icon: "error",
          buttons: "Ok",
        });
        setTimeout(() => {
          window.location.reload(false);
        }, 1000);
      }
    });
    setLoading(false);
  };

  // Delete
  const handleDelete = () => {
    setLoading(true);

    const data = {
      mms_city_id: parseInt(cityId),
      option: "delete",
      actionIds: isCheck,
    };
    swal({
      title: `Are you sure you want to delete selected Business?`,
      text: "Once deleted, you will not be able to recover!",
      icon: "error",
      buttons: true,
      dangerMode: false,
    }).then((willDelete) => {
      if (willDelete) {
        DeleteRowApi(data, () => {
          navigate("/");
        });
        swal({
          // title: "Success!",
          title: `Selected Business has been deleted successfully!`,
          icon: "success",
          buttons: false,
        });
        setTimeout(() => {
          window.location.reload(false);
        }, 1000);
      } else {
        swal({
          text: "Please wait...",
          icon: "error",
          buttons: "Ok",
        });

        setTimeout(() => {
          window.location.reload(false);
        }, 1000);
      }
    });
    setLoading(false);
  };

  const handleDeleteEach = (e, key) => {
    setLoading(true);

    const data = {
      mms_city_id: parseInt(cityId),
      option: "delete",
      actionIds: [TableRows[key].business_info_id],
    };
    swal({
      title: `Are you sure you want to delete ${TableRows[key].business_name}?`,
      text: "Once deleted, you will not be able to recover!",
      icon: "error",
      buttons: true,
      dangerMode: false,
    }).then((willDelete) => {
      if (willDelete) {
        DeleteRowApi(data, () => {
          navigate("/");
        });
        swal({
          // title: "Success!",
          title: `${TableRows[key].business_name} has been deleted successfully!`,
          icon: "success",
          buttons: false,
        });
        setTimeout(() => {
          window.location.reload(false);
        }, 1000);
      } else {
        swal({
          text: "Please wait...",
          icon: "error",
          buttons: "Ok",
        });

        setTimeout(() => {
          window.location.reload(false);
        }, 1000);
      }
    });
    setLoading(false);
  };

  // Notify - popup
  const handleNotifyEach = (e, key) => {
    navigate(
      `/business-listings/notify/${TableRows[key].category_id}-${TableRows[key].business_name}-${TableRows[key].category_name}-${TableRows[key].bu_id}`
    );
  };

  // request

  const handleRequestEach = async (e, key) => {
    const data = {
      mms_city_id: parseInt(cityId),
      bu_id: TableRows[key].bu_id,
    };
    const response = await BusinessPreviewAPi(data, () => {
      navigate("/");
    });
    if (response == false) {
      swal({
        title: NoDataText.InternalErr,
        icon: "error",
        buttons: "Ok",
        dangerMode: true,
      });
    } else {
      if (response.status === 429) {
        setLoading(true);
        swal({
          title: `${response.message}`,
          icon: "error",
          buttons: "OK",
        });
      } else if (response.success == false) {
        setNodata(true);
        setLoading(false);
        swal({
          title: `${response.message}`,
          icon: "error",
          buttons: "OK",
        });
      } else {
        setNodata(false);
        setLoading(false);
        const keyValues = Object.keys(response.data[0]);
        const feild_dict = {};
        keyValues.map((ykey, index) => (feild_dict[ykey] = index));

        const objNew = Object.keys(feild_dict).map(function (key, index) {
          // console.log(key,"key")
          const keyValue = key.replace(/_/g, " ");
          const keyLoopArr = keyValue.split(" ");
          for (var i = 0; i < keyLoopArr.length; i++) {
            keyLoopArr[i] =
              keyLoopArr[i].charAt(0).toUpperCase() + keyLoopArr[i].slice(1);
          }
          const finalResult = keyLoopArr.join(" ");
          // console.log(finalResult,"finalResult")
          return { business_status_id: index, business_status: finalResult };
        });

        setMissingFeildData(objNew);
        setModalShow(true);
        setrequest_id(TableRows[key].bu_id);
      }
    }
  };

  const handleRequestPopup = async (e, key) => {
    const data = {
      mms_city_id: parseInt(cityId),
    };
    const response = await RequestPopupAPI(data, () => {
      navigate("/");
    });
    if (response == false) {
      swal({
        title: NoDataText.InternalErr,
        icon: "error",
        buttons: "Ok",
        dangerMode: true,
      });
    } else {
      if (response.status === 429) {
        setLoading(true);
        swal({
          // title: "Error!",
          title: `${response.message}`,
          icon: "error",
          buttons: "OK",
        });
      } else if (response.success == false) {
        setNodata(true);
        setLoading(false);
        swal({
          title: `${response.message}`,
          icon: "error",
          buttons: "OK",
        });
      } else {
        setNodata(false);
        setLoading(false);
        setModalShow(true);
        setrequest_id(TableRows[key].bu_id);
        setMissingFeildData(response.data);
      }
    }
  };

  // checkbox - selectall -MissingFeild
  const handleSelectAllMissingFeild = (e) => {
    setMissingFeildErr("");
    setIsCheckAllMissingFeild(!isCheckAllMissingFeild);
    setIsCheckMissingFeild(MissingFeildData.map((li) => li));
    setisCheckMissingFeildvalue(MissingFeildData.map((li) => li));
    // setShowMissingFeilds(false);
    // setopenCount(openCount - 1);
    if (isCheckAllMissingFeild) {
      setIsCheckMissingFeild([]);
      setisCheckMissingFeildvalue([]);
    }
  };
  // checkbox - single -MissingFeild
  const handleClickMissingFeild = (e, key) => {
    setMissingFeildErr("");
    const { checked } = e.target;
    setIsCheckMissingFeild([...isCheckMissingFeild, MissingFeildData[key]]);
    setisCheckMissingFeildvalue([
      ...isCheckMissingFeildvalue,
      MissingFeildData[key],
    ]);
    if (!checked) {
      setIsCheckMissingFeild(
        isCheckMissingFeild.filter((item) => item !== MissingFeildData[key])
      );
      setisCheckMissingFeildvalue(
        isCheckMissingFeildvalue.filter(
          (item) => item !== MissingFeildData[key]
        )
      );
    }
  };

  // delete
  const removeTag = (e, key) => {
    setisCheckMissingFeildvalue(
      isCheckMissingFeildvalue.filter((el, i) => i !== key)
    );
    isCheckMissingFeildvalue.splice(key, 1);
    // if(isCheckMissingFeildvalue == 0){}
    setIsCheckMissingFeild(isCheckMissingFeild.filter((el, i) => i !== key));
    setIsCheckAllMissingFeild(!isCheckAllMissingFeild);
    // setShowMissingFeilds(false)
  };

  const SendRequest = async (e) => {
    e.preventDefault();
    if (isCheckMissingFeildvalue.length == 0) {
      setMissingFeildErr("* Please select missing field!");
    }
    // if (RequestMessage.length == 0) {
    //   setMessageEmptyErr("* Please enter message!");
    // }

    const data = {
      user_id: parseInt(cityId),
      business_id: parseInt(request_id),
      trigger_message: "Request for missing information",
      missing_fields: isCheckMissingFeildvalue,
      // message: RequestMessage,
    };
    if (
      isCheckMissingFeildvalue?.length != 0 &&
      MissingFeildErr?.length === 0 &&
      MessageEmptyErr?.length === 0
    ) {
      const response = await SaveRequestAPI(data, () => {
        navigate("/");
      });
      if (response == false) {
        swal({
          // title: "Error!",
          title: NoDataText.InternalErr,
          icon: "error",
          buttons: "Ok",
          dangerMode: true,
        });
      } else {
        if (response.status === 429) {
          setLoading(true);
          swal({
            // title: "Error!",
            title: `${response.message}!`,
            icon: "error",
            buttons: "Ok",
          });
        } else if (response.success == false) {
          setLoading(false);
          setModalShow(false);
          swal({
            // title: "Error!",
            title: `${response.message}!`,
            icon: "error",
            buttons: "Ok",
          });
        } else {
          setModalShow(false);
          setLoading(false);
          swal({
            title: `${response.message}!`,
            icon: "success",
            buttons: "Ok",
          });
          setTriggerData("");
          setRequestMessage("");
          setIsCheckMissingFeild([]);
          setisCheckMissingFeildvalue([]);
        }
      }
    }
  };

  // search
  const handleSearchInput = (e) => {
    setsearchValue(e.target.value);
    if (e.target.value.length == 0) {
      setShowTable(false);
      setTableRows(globalTableRows);
    }
  };

  const handleKeypress = (e) => {
    if (e.code === "Enter") {
      handleSearch();
    }
  };

  const handleSearch = async (e) => {
    setLoading(true);

    const data = {
      mms_city_id: parseInt(cityId),
      listing_for: listingNo,
      search_value: searchValue,
    };
    const coupondetailData = await BusinessListing(data, () => {
      navigate("/");
    });
    setLoading(false);
    if (coupondetailData == false) {
      swal({
        // title: "Error!",
        title: NoDataText.InternalErr,
        icon: "error",
        buttons: "Ok",
        dangerMode: true,
      });
    } else {
      if (coupondetailData.status === 429) {
        setLoading(true);
        setShowTable(false);
        swal({
          // title: "Error!",
          title: coupondetailData.message,
          icon: "error",
          // buttons: "Ok",
          dangerMode: true,
        });
      } else if (coupondetailData.message === "No Data Available") {
        setShowTable(true);
      } else {
        setShowTable(false);
        setTableRows(coupondetailData.data);
        setTotalPageCount(coupondetailData.total_count);
      }
    }
  };

  // export
  const handleExport = async (e) => {
    setLoading(true);

    const data = {
      mms_city_id: parseInt(cityId),
      listing_for: listingNo,
      export: true,
    };
    const coupondetailData = await SortAPi(data, () => {
      navigate("/");
    });

    let blob = new Blob([coupondetailData], {
      type: "application/vnd.ms-excel",
    });
    saveAs(blob, `${title}.xlsx`);
    setLoading(false);
  };

  // sort
  // Api for sort
  const handleSort = async (tab_id, search, sortNo, colValue) => {
    const data = {
      mms_city_id: parseInt(cityId),
      listing_for: tab_id,
      offset: search ? 0 : pageNumber,
      search_value: search,
      column_name: colValue,
      sort_type: sortNo,
    };
    const coupondetailData = await BusinessListing(data, () => {
      navigate("/");
    });
    setLoading(false);
    if (coupondetailData == false) {
      swal({
        // title: "Error!",
        title: NoDataText.InternalErr,
        icon: "error",
        buttons: "Ok",
        dangerMode: true,
      });
    } else {
      if (coupondetailData.status === 429) {
        setLoading(true);
        setShowTable(false);
        swal({
          // title: "Error!",
          title: coupondetailData.message,
          icon: "error",
          // buttons: "Ok",
          dangerMode: true,
        });
      } else if (coupondetailData.message === "No Data Available") {
        setShowTable(true);
      } else {
        setShowTable(false);
        setTableRows(coupondetailData.data);
        setglobalTableRows(coupondetailData.data);
        setTotalPageCount(coupondetailData.total_count);
        setLimit(coupondetailData.limit);
      }
    }
  };

  // function to sort-button
  const HandleSortCol = (value) => {
    // business_name: 0,
    if (value == "bi_name") {
      if (flag.business_name === 0) {
        handleSort(listingNo, searchValue, 1, "bi_name");
        setFlag((item) => {
          return { ...item, business_name: 1 };
        });
      } else if (flag.business_name === 1) {
        handleSort(listingNo, searchValue, 2, "bi_name");
        setFlag((item) => {
          return { ...item, business_name: 2 };
        });
      } else {
        handleSort(listingNo, searchValue, 0, "bi_name");
        setFlag((item) => {
          return { ...item, business_name: 0 };
        });
      }
    }
    // category: 0,
    if (value == "cat_name") {
      if (flag.category === 0) {
        handleSort(listingNo, searchValue, 1, "cat_name");
        setFlag((item) => {
          return { ...item, category: 1 };
        });
      } else if (flag.category === 1) {
        handleSort(listingNo, searchValue, 2, "cat_name");
        setFlag((item) => {
          return { ...item, category: 2 };
        });
      } else {
        handleSort(listingNo, searchValue, 0, "cat_name");
        setFlag((item) => {
          return { ...item, category: 0 };
        });
      }
    }
    // applied_date:0
    if (value == "created_at") {
      if (flag.applied_date === 0) {
        handleSort(listingNo, searchValue, 1, "created_at");
        setFlag((item) => {
          return { ...item, applied_date: 1 };
        });
      } else if (flag.applied_date === 1) {
        handleSort(listingNo, searchValue, 2, "created_at");
        setFlag((item) => {
          return { ...item, applied_date: 2 };
        });
      } else {
        handleSort(listingNo, searchValue, 0, "created_at");
        setFlag((item) => {
          return { ...item, applied_date: 0 };
        });
      }
    }
    // city: 0,
    if (value == "bup_city_id") {
      if (flag.city === 0) {
        handleSort(listingNo, searchValue, 1, "bup_city_id");
        setFlag((item) => {
          return { ...item, city: 1 };
        });
      } else if (flag.city === 1) {
        handleSort(listingNo, searchValue, 2, "bup_city_id");
        setFlag((item) => {
          return { ...item, city: 2 };
        });
      } else {
        handleSort(listingNo, searchValue, 0, "bup_city_id");
        setFlag((item) => {
          return { ...item, city: 0 };
        });
      }
    }
  };

  const handleEmailView = async (e, key) => {
    const data = {
      user_id: parseInt(cityId),
      business_id: TableRows[key].bu_id,
    };
    const arrayData = await EmailViewApi(data, () => {
      navigate("/");
    });
    if (arrayData.status === 429) {
      setLoading(true);
      swal({
        // title: "Error!",
        title: `${arrayData.message}`,
        icon: "error",
        buttons: "OK",
      });
    } else if (arrayData == false) {
      swal({
        // title: "Error!",
        title: NoDataText.InternalErr,
        icon: "error",
        buttons: "Ok",
        dangerMode: true,
      });
    } else {
      if (arrayData.success == true) {
        setEmailStatusmodalShow(true);
        if (arrayData.success === true) {
          setEmailData(arrayData.data);
        } else {
          setEmailData([]);
        }
      } else {
        swal({
          // title: "Error!",
          title: arrayData.message,
          icon: "error",
          buttons: "Ok",
          dangerMode: true,
        });
      }
    }
  };

  // add-category-list
  const ShowCategories = async () => {
    const data = {
      mms_city_id: parseInt(cityId),
    };
    const response = await MarketPlaceCategoryListAPI(data, () => {
      navigate("/");
    });
    if (response.success === false) {
      setLoading(false);
      setbussinessCategory([]);
    } else {
      const categories = response.data;
      // Function to move object to the end of array
      function moveOthersToEnd(arr) {
        let othersIndex = arr.findIndex(
          (obj) => obj.cat_name.toLowerCase() === "others"
        );
        if (othersIndex !== -1) {
          let othersObj = arr.splice(othersIndex, 1)[0];
          arr.push(othersObj);
        }
      }

      // Move "others" to end of array
      moveOthersToEnd(categories);

      // Output the modified array
      //  console.log(categories);

      setbussinessCategory(categories);
      setLoading(false);
    }
  };

  useEffect(() => {
    ShowCategories();
  }, []);

  // update status
  const CategoriesSelect = (e, key) => {
    // console.log(TableRows[key], "ss");
    setLoading(true);

    const data = {
      mms_city_id: parseInt(cityId),
      business_id: TableRows[key].business_info_id,
      category_id: parseInt(e.target.value),
    };
    swal({
      title: `Are you sure you want to update market place category of ${TableRows[key].business_name}?`,
      icon: "warning",
      buttons: true,
      dangerMode: false,
    }).then((willDelete) => {
      if (willDelete) {
        setLoading(true);
        CategorySelectAPI(data, () => {
          navigate("/");
        });
        swal({
          title: `${TableRows[key].business_name} market place category has been updated successfully!`,
          icon: "success",
          buttons: "Ok",
        }).then((willDelete) => {
          if (willDelete) {
            window.location.reload(false);
          }
        });
      } else {
        swal({
          text: "Please wait...",
          icon: "error",
          buttons: "Ok",
        });
        setTimeout(() => {
          window.location.reload(false);
        }, 500);
      }
    });
    setLoading(false);
  };

  const getListing = async () => {
    const cityId = localStorage.getItem("cityId");
    const data = {
      mms_city_id: parseInt(cityId),
      listing_for: 5,
      offset: pageNumber,
    };
    try {
      const response = await getFeaturedListingApi(data);
      if (response.status === 429) {
        setLoading(true);
        swal({
          title: `${response.message}`,
          icon: "error",
          buttons: "OK",
        });
      } else if (response == false) {
        setLoading(false);
        swal({
          title: `Internal server error`,
          icon: "error",
          buttons: "OK",
        });
      } else {
        const apiItems = response.data.map((item) => ({
          id: item.bu_id.toString(),
          content: item,
        }));
        setItems(apiItems);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      console.error("Error fetching data:", error);
    }
  };

  const handleFeatureStatus = async (
    checked,
    businessId,
    businessName,
    tabName
  ) => {
    setFeatureStatus((prevState) => ({
      ...prevState,
      [businessId]: checked,
    }));

    const payload = {
      mms_city_id: parseInt(cityId),
      bu_id: businessId,
      action_key: checked === true ? "enable" : "disable",
    };

    if (tabName === "publish") {
      try {
        const response = await UpdateFeatureStatusApi(payload);
        if (response.status === 429) {
          setLoading(true);
          swal({
            title: `${response.message}`,
            icon: "error",
            buttons: "OK",
          });
        } else if (response === false) {
          setLoading(false);
          swal({
            title: `${response.message}`,
            icon: "error",
            buttons: "OK",
          });
        } else if (response.status === 400) {
          swal({
            title: `${response.message}`,
            icon: "error",
            buttons: "OK",
          }).then(() => {
            setLoading(true);
            window.location.reload();
          });
        } else {
          setLoading(false);
          handleBussinessListing(3);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    } else {
      swal({
        title: `Are you sure you want to remove "${businessName}" business from the featured listings?`,
        icon: "warning",
        buttons: true,
        dangerMode: false,
      }).then(async (willDelete) => {
        if (willDelete) {
          setLoading(true);
          try {
            const response = await UpdateFeatureStatusApi(payload);
            if (response.status === 429) {
              setLoading(true);
              swal({
                title: `${response.message}`,
                icon: "error",
                buttons: "OK",
              });
            } else if (response === false) {
              setLoading(false);
              swal({
                title: `${response.message}`,
                icon: "error",
                buttons: "OK",
              });
            } else if (response.status === 400) {
              swal({
                title: `${response.message}`,
                icon: "error",
                buttons: "OK",
              }).then(() => {
                setLoading(true);
                window.location.reload();
              });
            } else {
              getListing();
              setLoading(false);
              swal({
                title: `The "${businessName}" business has been successfully removed from the featured listings.`,
                icon: "success",
                buttons: "Ok",
              });
            }
          } catch (error) {
            setLoading(false);
            console.error("Error fetching data:", error);
          }
        }
      });
    }
  };

  // update-listing
  const handleUpdateFeatureList = async () => {
    setLoading(true);
    try {
      const updatedIds = items.map((item) => parseInt(item.id));
      const data = {
        mms_city_id: parseInt(cityId),
        featured_order_busi_id: updatedIds,
      };
      const response = await UpdateFeatureListApi(data);
      if (response.success === true && response.status === 200) {
        setLoading(false);
        swal({
          title: `${response.message}`,
          icon: "success",
          buttons: "OK",
        });
        setIsReorder(false);
      } else {
        if (response.status === 429 || 400) {
          setLoading(false);
          swal({
            title: `${response.message}`,
            icon: "error",
            buttons: "OK",
          });
        }
      }
    } catch (error) {
      setLoading(false);
      console.log("Api error:", error);
    }
  };

  return (
    <>
      {loading ? <Loader /> : ""}
      <div className="gray-bg">
        <div className="navbar-section p-0">
          <SideBar />
        </div>

        <div className="main-content pt-5 pr-3 pb-4">
          <BackButton />
          <p className="page-maintitle">Business Listings</p>
          <div className="acc-dashboard mt-4 BListings-tabs">
            <TabsSection />
            <div
              className={
                endPath[4] !== "featured-listings"
                  ? "manage-vou-main pt-3 pb-3 Blist"
                  : "manage-feature pt-3 pb-3 Blist"
              }
            >
              <div style={{ width: "59%" }}>
                <p className="page-maintitle pt-2">{title}</p>
                {endPath[4] === "featured-listings" ? (
                  <p className="page-subtitle">
                    Drag and drop the listings to rearrange them in your desired
                    order, then click Save to apply any changes.
                  </p>
                ) : (
                  <p className="page-subtitle">
                    Any business with published status will be visible in the
                    marketplace
                  </p>
                )}
              </div>

              {endPath[4] === "featured-listings" ? (
                <div
                  className={
                    endPath[4] !== "featured-listings" ? "manage-vou" : ""
                  }
                >
                  <div
                    variant="primary"
                    className={`add-new-btn btn-container ${
                      isReorder ? "item-dragged" : "item-not-dragged"
                    }`}
                    onClick={isReorder ? handleUpdateFeatureList : null}
                    style={{ fontSize: 16 }}
                  >
                    Save
                  </div>
                </div>
              ) : (
                <div className="manage-vou">
                  <InputGroup className="search-bar">
                    <InputGroup.Text>
                      <MdSearch />
                    </InputGroup.Text>
                    <Form.Control
                      className="search_feild"
                      value={searchValue}
                      onChange={(e) => handleSearchInput(e)}
                      onKeyPress={handleKeypress}
                      placeholder="Search Business"
                    />
                    <Button variant="outline-secondary" onClick={handleSearch}>
                      Search
                    </Button>
                  </InputGroup>
                  <div
                    variant="primary"
                    className="create-btn export-btn-main"
                    onClick={handleExport}
                  >
                    Export <MdOutlineLogout className="export-btn" />
                  </div>
                </div>
              )}
            </div>
            {endPath[4] !== "featured-listings" && (
              <SearchBarResults SearchValue={searchValue} />
            )}

            {endPath[4] !== "featured-listings" ? (
              <>
                {isCheck.length != 0 ? (
                  <div className="d-flex">
                    <Button
                      className="green-btn width-150 p-0 mr-3"
                      onClick={handleDelete}
                    >
                      Delete Selected
                    </Button>
                    <Form.Select
                      aria-label="Default select example"
                      className="table-select width-150 ml-3 status_select"
                      onChange={handleChangeDropDownTop}
                    >
                      <option>Select Status</option>
                      {TableRows.length != 0 ? (
                        <>
                          {TableRows[0]?.status_option.map((i, k) => {
                            return <option value={i.id}>{i.status} </option>;
                          })}
                        </>
                      ) : (
                        ""
                      )}
                    </Form.Select>
                  </div>
                ) : (
                  ""
                )}
                {/* <span>Number of Business Listing : {TableRows.length}</span> */}
                <div class="table-responsive-xl black-header">
                  <table class="recentact-table mt-3 table ver-middle manage-vou-table bus-list-Table">
                    <thead>
                      <tr>
                        <th className="radio-colors">
                          <Form.Check
                            aria-label="option 1"
                            className="orange-checkbox"
                            onChange={handleSelectAll}
                            checked={isCheckAll}
                          />
                        </th>
                        <th
                          onClick={() => HandleSortCol("bi_name")}
                          width="300px"
                        >
                          <Button className="btn btn-primary sortIcon">
                            Business Name
                            {flag.business_name === 0 ? (
                              <FaSort></FaSort>
                            ) : flag.business_name === 1 ? (
                              <FaSortUp></FaSortUp>
                            ) : (
                              <FaSortDown></FaSortDown>
                            )}
                          </Button>
                        </th>
                        <th onClick={() => HandleSortCol("cat_name")}>
                          <Button className="btn btn-primary sortIcon">
                            Category{" "}
                            {flag.category === 0 ? (
                              <FaSort></FaSort>
                            ) : flag.category === 1 ? (
                              <FaSortUp></FaSortUp>
                            ) : (
                              <FaSortDown></FaSortDown>
                            )}
                          </Button>
                        </th>
                        <th>Marketplace Category</th>
                        <th>Primary Contact</th>
                        <th onClick={() => HandleSortCol("created_at")}>
                          <Button className="btn btn-primary sortIcon">
                            Applied Date
                            {flag.applied_date === 0 ? (
                              <FaSort></FaSort>
                            ) : flag.applied_date === 1 ? (
                              <FaSortUp></FaSortUp>
                            ) : (
                              <FaSortDown></FaSortDown>
                            )}
                          </Button>
                        </th>
                        <th onClick={() => HandleSortCol("bup_city_id")}>
                          <Button
                            className="btn btn-primary sortIcon"
                            style={{
                              width: "100%",
                              display: "flex",
                              justifyContent: "center",
                            }}
                          >
                            City
                            {flag.city === 0 ? (
                              <FaSort></FaSort>
                            ) : flag.city === 1 ? (
                              <FaSortUp></FaSortUp>
                            ) : (
                              <FaSortDown></FaSortDown>
                            )}
                          </Button>
                        </th>
                        <th>Status</th>
                        {endPath[4] === "published-listings" && (
                          <th>Featured</th>
                        )}

                        <th className="action-min-main">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {ShowTable == false ? (
                        <>
                          {TableRows.length > 0 ? (
                            TableRows?.map((item, key) => {
                              return (
                                <>
                                  <tr>
                                    <td className="radio-colors">
                                      <Form.Check
                                        aria-label="option 1"
                                        className="orange-checkbox"
                                        onChange={(e) => handleClick(e, key)}
                                        checked={isCheck.includes(
                                          item.business_info_id,
                                        )}
                                      />
                                    </td>
                                    <td style={{ textAlign: "left" }}>
                                      <Link
                                        className="vouname-blue"
                                        to={`/business-listings/preview/${item.bu_id}`}
                                      >
                                        {item.business_name}
                                      </Link>
                                    </td>
                                    <td>{item.category_name}</td>

                                    {/* cat */}

                                    <td>
                                      {" "}
                                      <Form.Select
                                        aria-label="Default select example"
                                        className="table-select status_select"
                                        onChange={(e) =>
                                          CategoriesSelect(e, key)
                                        }
                                      >
                                        <option>Select</option>
                                        {bussinessCategory.length == 0 ? (
                                          <option disabled>Select</option>
                                        ) : (
                                          <>
                                            {" "}
                                            {bussinessCategory.map((i, k) => {
                                              return (
                                                <option
                                                  value={i.cat_id}
                                                  title={i.cat_name}
                                                  disabled={
                                                    item.category_name ==
                                                    i.cat_name
                                                      ? "disabled"
                                                      : ""
                                                  }
                                                  selected={
                                                    item.mms_category_id ===
                                                    i.cat_id
                                                      ? "selected"
                                                      : ""
                                                  }
                                                >
                                                  {i.cat_name}
                                                </option>
                                              );
                                            })}
                                          </>
                                        )}
                                      </Form.Select>
                                    </td>

                                    <td>
                                      {item.first_name} {item.last_name}
                                      <br />
                                      {item.contact_name}
                                    </td>
                                    <td className="date-col">
                                      {FormatDateShortMonth(item.applied_date)}
                                    </td>

                                    <td>{item.city_id}</td>
                                    <td>
                                      <Form.Select
                                        aria-label="Default select example"
                                        className="table-select status_select"
                                        onChange={(e) =>
                                          handleChangeDropDown(e, key)
                                        }
                                      >
                                        {item.status_option.map((i, k) => {
                                          return (
                                            <option
                                              value={i.id}
                                              selected={
                                                item.approval_status === i.id
                                                  ? "selected"
                                                  : ""
                                              }
                                            >
                                              {i.status}
                                            </option>
                                          );
                                        })}
                                      </Form.Select>
                                    </td>
                                    {endPath[4] === "published-listings" && (
                                      <td>
                                        <Switch
                                          className="switch-button"
                                          checkedChildren="Enable"
                                          unCheckedChildren="Disable"
                                          checked={
                                            featureStatus[item.bu_id] ||
                                            item.is_featured === true
                                              ? true
                                              : false
                                          }
                                          onChange={(checked) => {
                                            handleFeatureStatus(
                                              checked,
                                              item.bu_id,
                                              item.business_name,
                                              "publish",
                                            );
                                          }}
                                        />
                                      </td>
                                    )}

                                    <td>
                                      <div className="action-min-img">
                                        <div
                                          alt="Email"
                                          onClick={(e) =>
                                            handleEmailView(e, key)
                                          }
                                        >
                                          <Image
                                            src={emailpic}
                                            className="width-30"
                                            title="Email"
                                          ></Image>
                                        </div>

                                        <Dropdown id="dropdown-basic">
                                          <Dropdown.Toggle
                                            variant="success"
                                            id="dropdown-basic1"
                                            className="bg-transparent border-0"
                                          >
                                            <div className="hmenu">
                                              <img src={More} title="More" />
                                            </div>
                                          </Dropdown.Toggle>

                                          <Dropdown.Menu>
                                            <Dropdown.Item
                                              className="dropdownItem"
                                              onClick={(e) =>
                                                handleRequestPopup(e, key)
                                              }
                                            >
                                              <img src={More2} />
                                              Request
                                            </Dropdown.Item>
                                            <Dropdown.Item
                                              className="dropdownItem"
                                              onClick={(e) =>
                                                handleNotifyEach(e, key)
                                              }
                                            >
                                              <img src={More1} />
                                              Notify
                                            </Dropdown.Item>

                                            <Dropdown.Item
                                              className="dropdownItem"
                                              onClick={(e) =>
                                                handleDeleteEach(e, key)
                                              }
                                            >
                                              <img src={More4} /> Delete
                                            </Dropdown.Item>
                                          </Dropdown.Menu>
                                        </Dropdown>

                                        <p className="read-more-link pt-1">
                                          {selctedRow != key ? (
                                            <img
                                              src={add}
                                              onClick={(e) => {
                                                handleOpenPlus(e, key);
                                              }}
                                              title="Show"
                                            />
                                          ) : (
                                            <img
                                              src={remove}
                                              onClick={(e) => {
                                                handleClosePlus(e, key);
                                              }}
                                              title="Hide"
                                            />
                                          )}
                                        </p>
                                      </div>
                                    </td>
                                  </tr>

                                  {expandedRows == item.bu_id ? (
                                    <tr className="toggle-row">
                                      {/* {Nodata == false ? (
                                
                                ) : (
                                  <td colSpan={8}>
                                    <p className="noData">{NoDataText.ErrText}</p>{" "}
                                  </td>
                                )} */}

                                      <td colSpan={9}>
                                        <Row className="dashboard-card BListingCards TableListing">
                                          <Col md="3">
                                            <div className="card green-card">
                                              <div className="dash-img-main">
                                                <div className="dash-img">
                                                  <Image
                                                    src={Dash5}
                                                    height="22px"
                                                  ></Image>
                                                </div>
                                              </div>
                                              <div className="dash-content">
                                                <p className="dash-text1 pt-4">
                                                  Total Vouchers
                                                </p>
                                                <p className="dash-text2">
                                                  {Nodata == true
                                                    ? "0"
                                                    : expandedRowsData.total_voucher}
                                                </p>
                                                <p className="text-right pb-3"></p>
                                              </div>
                                            </div>
                                          </Col>
                                          <Col md="3">
                                            <div className="card green-card">
                                              <div className="dash-img-main">
                                                <div className="dash-img">
                                                  <Image
                                                    src={Savings}
                                                    height="20px"
                                                  ></Image>
                                                </div>
                                              </div>
                                              <div className="dash-content">
                                                <p className="dash-text1 pt-4">
                                                  Life Time Sales
                                                </p>
                                                <p className="dash-text2">
                                                  $
                                                  {Nodata == true
                                                    ? "0"
                                                    : expandedRowsData.life_time_sale}
                                                </p>
                                                <p className="text-right pb-3"></p>
                                              </div>
                                            </div>
                                          </Col>
                                          <Col md="3">
                                            <div className="card green-card">
                                              <div className="dash-img-main">
                                                <div className="dash-img">
                                                  <Image
                                                    src={Dash3}
                                                    height="24px"
                                                  ></Image>
                                                </div>
                                              </div>
                                              <div className="dash-content">
                                                <p className="dash-text1 pt-4">
                                                  Year To Date Sales
                                                </p>
                                                <p className="dash-text2">
                                                  $
                                                  {Nodata == true
                                                    ? "0"
                                                    : expandedRowsData.year_todate_sales}
                                                </p>
                                                <p className="text-right pb-3"></p>
                                              </div>
                                            </div>
                                          </Col>
                                          <Col md="3">
                                            <div className="card green-card">
                                              <div className="dash-img-main">
                                                <div className="dash-img">
                                                  <Image
                                                    src={Dash4}
                                                    height="22px"
                                                  ></Image>
                                                </div>
                                              </div>
                                              <div className="dash-content">
                                                <p className="dash-text1 pt-4">
                                                  This Month Sales
                                                </p>
                                                <p className="dash-text2">
                                                  $
                                                  {Nodata == true
                                                    ? "0"
                                                    : expandedRowsData.this_month_sales}
                                                </p>
                                                <p className="text-right pb-3"></p>
                                              </div>
                                            </div>
                                          </Col>
                                        </Row>
                                      </td>
                                    </tr>
                                  ) : (
                                    ""
                                  )}
                                </>
                              );
                            })
                          ) : (
                            <tr class="toggle-row">
                              <td colspan={9}>
                                <p class="noData">{NoDataText.ErrText}</p>{" "}
                              </td>
                            </tr>
                          )}
                        </>
                      ) : (
                        <tr class="toggle-row">
                          <td colspan={9}>
                            <p class="noData">{NoDataText.ErrText}</p>{" "}
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
                {totalPageCount > 10 ? (
                  <Pagination
                    totalPageCount={totalPageCount}
                    setPageNumber={setPageNumber}
                    limit={limit}
                  />
                ) : (
                  <></>
                )}
              </>
            ) : (
              <>
                <FeaturedListing
                  items={items}
                  setItems={setItems}
                  pageNumber={pageNumber}
                  handleFeatureStatus={handleFeatureStatus}
                  setLoading={setLoading}
                  setIsReorder={setIsReorder}
                  getListing={getListing}
                />
              </>
            )}
          </div>
        </div>
      </div>
      <PrivacyTermsConditions />

      {/* popups */}
      <Modal
        show={modalShow}
        onHide={() => {
          setModalShow(false);
          setTriggerData("");
          setRequestMessage("");
          setIsCheckMissingFeild([]);
          setisCheckMissingFeildvalue([]);
        }}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="popup-modal w-600"
      >
        <Modal.Header className="requestCloseBtn" closeButton></Modal.Header>
        <Modal.Body className="mb-5 requestPopup">
          <p
            className="page-maintitle text-center"
            style={{ color: "#E66100" }}
          >
            Send Request
          </p>
          <Row className="RequestPopDetails">
            {/* <Col md="2"></Col> */}
            <Col md="8" className="modelBodRequest">
              <Form className="formmain mx-2 mt-4 signin-row profile-form pb-4 RequestForm">
                <Row>
                  <Col md="12" className="">
                    <Form.Group className="mb-3" controlId="formBasicEmail">
                      <Form.Label className="form-label-custom">
                        Trigger <span className="star-required"></span>
                      </Form.Label>
                      <InputGroup className="edit-border">
                        <Form.Control
                          autoComplete="off"
                          type="text"
                          value={"Request for missing information"}
                          className="custom-formcontrol request_Missing_info not_Allowed_Click"
                          style={{
                            background: "#c4c4c4",
                            cursor: "not-allowed",
                            userSelect: "none",
                          }}
                          readOnly
                          // onChange={(e) => setTriggerData(e.target.value)}
                        />
                      </InputGroup>
                    </Form.Group>
                  </Col>
                  <Col md="12" className="">
                    <Form.Group className="mb-3" controlId="formBasicEmail">
                      <Form.Label className="form-label-custom">
                        Missing fields <span className="star-required">*</span>
                      </Form.Label>

                      {isCheckMissingFeild.length != 0 ? (
                        <div>
                          <div
                            className="sel_items"
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              setShowMissingFeilds(!ShowMissingFeilds)
                            }
                          >
                            {isCheckMissingFeildvalue.map((eachItem, key) => {
                              return (
                                <div
                                  className="save-item"
                                  style={{ backgroundColor: "#EFEFEF" }}
                                  key={key}
                                >
                                  <span style={{ color: "rgb(230, 97, 0)" }}>
                                    {eachItem}
                                  </span>
                                  <MdClose
                                    style={{ marginLeft: 8 }}
                                    className="delete_item"
                                    onClick={(e) => removeTag(e, key)}
                                  />
                                </div>
                              );
                            })}
                          </div>
                          <img
                            className="arrowDown_drop"
                            src={arrowDown}
                            // onClick={ShowCheckbox}
                          />
                        </div>
                      ) : (
                        <form>
                          <div
                            class="multiselect bulk-notify"
                            onClick={() =>
                              setShowMissingFeilds(!ShowMissingFeilds)
                            }
                            style={{ cursor: "pointer" }}
                          >
                            <div class="selectBox bulk-notify">
                              <select>
                                <option>Select missing fields</option>
                              </select>
                              <img
                                className="arrow-down-bulk"
                                src={arrowDown}
                              />
                              <div class="overSelect bulk-notify"></div>
                            </div>
                          </div>
                        </form>
                      )}

                      {/* remove */}
                      {/* <OutsideClickHandler
                    onOutsideClick={() => {
                      // setShowBussinessList(false)
                      setShowMissingFeilds(false)
                    }}
                  > */}
                      {ShowMissingFeilds && (
                        <div id="checkboxes" className="orange-checkbox">
                          <label
                            for="one"
                            className="checkbox-label bulk-notify-label"
                          >
                            <input
                              type="checkbox"
                              id="one"
                              className="form-check-input bulk-notify-list"
                              onChange={handleSelectAllMissingFeild}
                              checked={isCheckAllMissingFeild}
                            />
                            Select All
                          </label>

                          {MissingFeildData.map((item, key) => {
                            return (
                              <>
                                <div className="orange-checkbox">
                                  <label
                                    for={item}
                                    value={item}
                                    className="checkbox-label bulk-notify-label"
                                  >
                                    <input
                                      type="checkbox"
                                      id={item}
                                      className="form-check-input bulk-notify-list"
                                      onChange={(e) =>
                                        handleClickMissingFeild(e, key)
                                      }
                                      checked={isCheckMissingFeild.includes(
                                        item,
                                      )}
                                    />
                                    {item}
                                  </label>
                                </div>
                              </>
                            );
                          })}
                        </div>
                      )}
                      {/* </OutsideClickHandler> */}
                    </Form.Group>
                    {MissingFeildErr && (
                      <p className="text-danger">{MissingFeildErr}</p>
                    )}
                  </Col>
                  {/* <Col md="12" className="">
                    <Form.Label className="form-label-custom edit-sec">
                      Message <span className="star-required"></span>
                    </Form.Label>
                    <Form.Group
                      className="mb-0"
                      controlId="exampleForm.ControlTextarea1"
                      placeholder="Type Something"
                      onChange={(e) => {
                        setRequestMessage(e.target.value);
                        setMessageEmptyErr("");
                      }}
                    >
                      <Form.Control
                        as="textarea"
                        rows={5}
                        value={RequestMessage}
                      />
                    </Form.Group>
                    {MessageEmptyErr && (
                      <p className="text-danger">{MessageEmptyErr}</p>
                    )}
                  </Col> */}
                </Row>
                <div className="text-center d-flex">
                  <Button
                    variant="primary"
                    type="submit"
                    className="green-btn mt-3"
                    onClick={(e) => SendRequest(e)}
                  >
                    Send
                  </Button>
                </div>
              </Form>
            </Col>
            {/* <Col md="2"></Col> */}
          </Row>
        </Modal.Body>
      </Modal>
      {/* email */}
      <Modal
        show={EmailStatusmodalShow}
        onHide={() => setEmailStatusmodalShow(false)}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="popup-modal w-1000 email-popup"
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body className="">
          <div class="table-responsive-xl black-header emailTable">
            <table class="recentact-table mt-3 table ver-middle manage-vou-table BusinessListingMailPop">
              <thead>
                <tr>
                  <th>Template Name</th>
                  <th>Sent By</th>
                  <th>Date</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {EmailData.length != 0 ? (
                  <>
                    {EmailData.map((i, k) => {
                      const DateValue = new Date(i.created_at);
                      const shortMonth = DateValue.toLocaleString("en-US", {
                        month: "short",
                      });
                      const day = DateValue.toLocaleString("en-US", {
                        day: "numeric",
                      });
                      const year = DateValue.toLocaleString("en-US", {
                        year: "numeric",
                      });
                      const finaldate = shortMonth + "-" + day + "-" + year;

                      return (
                        <tr>
                          <td>{i.template_name}</td>
                          <td>{i.sent_by_name}</td>
                          <td>{finaldate}</td>
                          <td>
                            <Button className={`email-sent_${i.email_status}`}>
                              {i.email_status}
                            </Button>
                          </td>
                        </tr>
                      );
                    })}
                  </>
                ) : (
                  <tr>
                    <td colSpan={4}>
                      <p className="noData">{NoDataText.ErrText}</p>{" "}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default BusinessListings;
